export enum LetterGenerationStatus {
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  REQUESTED = 'REQUESTED',
  CANCELLED = 'CANCELED',
}
